import Topbar from "./topbar.jsx"
import Sidebar from "./sidebar.jsx"
import Operation from "./operation.jsx"
import Operations from "./operations.jsx"
import Parameters from "./parameters.jsx"
import ParameterRow from "./parameter-row.jsx"
import Responses from "./responses.jsx"
import Response from "./response.jsx"
import ModelExample from "./model-example.jsx"

export default function () {
  return {
    components: {
      Topbar,
      Sidebar
    }
  }
}


// WEBPACK FOOTER //
// ./src/plugins/thinkhr/index.js